import { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState("login"); // login | register
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = mode === "login"
      ? await login(email, password)
      : await register(email, password, name || "Guest");
    setBusy(false);
    if (!res.ok) toast.error(res.error);
    else toast.success(mode === "login" ? "Welcome back" : "Welcome to the Club");
  };

  const useDemo = async () => {
    setBusy(true);
    const res = await login("member@duckandrice.com", "dimsum2026");
    setBusy(false);
    if (!res.ok) toast.error(res.error);
  };

  return (
    <div className="login-shell" data-testid="login-page">
      <div className="login-card">
        <div className="login-hatch" />
        <div className="login-body">
          <div className="duck-logo duck-logo--black login-duck" data-testid="login-duck-logo" />
          <div className="login-eyebrow">SOHO · BATTERSEA · DIFC · MEMBERS CLUB</div>

          <div className="login-divider" />

          <h1 className="login-title">{mode === "login" ? "Welcome back" : "Apply for membership"}</h1>
          <p className="login-sub">
            {mode === "login"
              ? "Tiles, bookings and Linner Club await."
              : "A digital pass to the Chinese pub on Berwick Street."}
          </p>

          <form onSubmit={submit} className="login-form">
            {mode === "register" && (
              <label className="login-field">
                <span>NAME</span>
                <input
                  data-testid="name-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  required
                />
              </label>
            )}
            <label className="login-field">
              <span>EMAIL</span>
              <input
                data-testid="email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@duckandrice.com"
                required
              />
            </label>
            <label className="login-field">
              <span>PASSWORD</span>
              <input
                data-testid="password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                minLength={4}
              />
            </label>

            <button
              data-testid="submit-auth-btn"
              type="submit"
              disabled={busy}
              className="login-submit"
            >
              {busy ? "…" : mode === "login" ? "ENTER THE CLUB" : "JOIN THE CLUB"}
            </button>
          </form>

          <button
            data-testid="demo-login-btn"
            type="button"
            onClick={useDemo}
            disabled={busy}
            className="login-demo"
          >
            ◈ ENTER AS DEMO MEMBER
          </button>

          <button
            data-testid="toggle-auth-mode"
            type="button"
            className="login-toggle"
            onClick={() => setMode(mode === "login" ? "register" : "login")}
          >
            {mode === "login" ? "First time? Apply for membership →" : "Already a member? Sign in →"}
          </button>

          <div className="login-foot">
            EST. SOHO · CROWN COLONY OF HK INSPIRED
          </div>
        </div>
      </div>
    </div>
  );
}
